<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="7" height="9" rx="1.5" stroke="currentColor" stroke-width="1.7" />
        <rect x="14" y="3" width="7" height="5" rx="1.5" stroke="currentColor" stroke-width="1.7" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" stroke="currentColor" stroke-width="1.7" />
        <rect x="3" y="16" width="7" height="5" rx="1.5" stroke="currentColor" stroke-width="1.7" />
    </svg>
</template>
